import {useMemo} from 'react'

import {selectTheme} from '../../store'

export const useDataDownloadDesignTokens = () => {
  const {color, fontWeight} = selectTheme()

  return useMemo(
    () => ({
      bg: '#F4F5F7',
      surface: color.surface.white,
      surface2: '#FAFBFC',
      fg: '#0F172A',
      muted: '#64748B',
      border: '#E5E7EB',
      border2: '#EEF0F3',
      accent: '#3D5BF6',
      accentHover: '#2F49DC',
      accentSoft: '#EEF1FF',
      amber: '#F59E0B',
      amberSoft: '#FFF7E6',
      green: '#10B981',
      greenSoft: '#E7F8F1',
      slate: '#94A3B8',
      slateSoft: '#F1F5F9',
      danger: '#DC2626',
      dangerSoft: '#FEF2F2',
      dangerBorder: '#FECACA',
      rowText: '#334155',
      rowValue: '#1E293B',
      hoverBorder: '#CBD5E1',
      newButtonHover: '#E4E9FF',
      scrollbarThumb: '#D1D5DB',
      activeRingShadow: '0 0 0 3px rgba(61,91,246,0.12)',
      dialogOverlay: 'rgba(0,0,0,0.3)',
      dialogShadow: '0 8px 32px rgba(0,0,0,0.12)',
      zippingPanelBackground: 'oklch(98% 0.025 80)',
      zippingPanelBorder: 'oklch(90% 0.04 80)',
      zippingRing: 'oklch(85% 0.08 80)',
      zippingProgressBackground: 'oklch(90% 0.05 80)',
      zippingProgressGradient: 'linear-gradient(90deg, #F59E0B, oklch(72% 0.16 80))',
      zippingRemaining: '#D97706',
      radiusSm: '6px',
      radius: '8px',
      radiusLg: '12px',
      font: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif',
      fontSize: {
        base: 14,
        topbar: 13,
        button: 12.5,
        buttonLarge: 13.5,
        status: 11,
        sidebarTitle: 15,
        sidebarMeta: 12,
        cardBody: 12.5,
        cardLabel: 12,
        cardSub: 11,
        newButton: 14,
        newButtonIcon: 22,
        newButtonSub: 12,
        emptyState: 13,
        sectionTitle: 13,
        sectionMeta: 12,
        participantRow: 13,
        timeOptionTitle: 13.5,
        timeOptionSub: 12,
        dateField: 12.5,
        paneTitle: 22,
        paneSubtitle: 13.5,
        fileHeading: 13,
        fileRow: 13,
        fileMeta: 11.5,
        fileSize: 12.5,
        expiry: 12.5,
        statLabel: 11,
        statValue: 16,
        statSub: 12,
        participantPillTitle: 13,
        participantPill: 11.5,
        zippingTitle: 14.5,
        zippingSubtitle: 12,
        zippingPercent: 36,
        zippingPercentSup: 16,
        dialogTitle: 16,
        dialogBody: 13.5,
      },
      fontWeight,
    }),
    [color.surface.white, fontWeight],
  )
}
